const ChatStreamPayloadType = {
  ERROR            : 'ERROR',
  PARTIAL_MESSAGE  : 'PARTIAL_MESSAGE',
  COMPLETED_MESSAGE: 'COMPLETED_MESSAGE',
  TITLE_UPDATE     : 'TITLE_UPDATE',
  TOOL_EXECUTION   : 'TOOL_EXECUTION',
  STOP_FINISHED    : 'STOP_FINISHED'
}

export default ChatStreamPayloadType
